import { UserDTO } from './common/Dtos';
import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, Grid, TextField } from '@material-ui/core';
import { SDialogButton, SDialogTitle } from './common/BCommonComponents';

interface AggiungiEmailDialogProps {
	open: boolean;
	onClose: (userDTO?: UserDTO) => void;
	userDTO: UserDTO;
}

function AggiungiEmailDialog(props: AggiungiEmailDialogProps) {
	const { onClose, open } = props;
	const [email, setEmail] = useState<string>();
	const [emailRepeat, setEmailRepeat] = useState<string>();
	const [user, setUser] = useState<UserDTO>(props.userDTO);
	const [erroremail, setErroremail] = useState<boolean>(false);

	useEffect(() => {
	}, [email, emailRepeat]);

	useEffect(() => {
		setEmail('');
		setEmailRepeat('');
		setUser(props.userDTO);
	}, [open]);

	const handleConferma = () => {
		const newUser: UserDTO = {
			...user,
			email: email ? email : ''
		}

		if (email && email !== '' && emailRepeat && emailRepeat !== '') {
			const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (email === emailRepeat && regex.test(email)) {
				console.log("entra");
				onClose(newUser);
			} else {
				setErroremail(true);
			}
		}

	};

	const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let value = event.target.value;
		setEmail(value);
	};

	const handleEmailRepeatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let value = event.target.value;
		setEmailRepeat(value);
	};
	return (
		<Dialog
			disableBackdropClick
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">INSERISCI LA TUA EMAIL</SDialogTitle>
			<DialogContent>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={12} className="px-2">
						<TextField
							className="w-100"
							id="email"
							label="Email"
							variant="outlined"
							value={email}
							onPaste={(e) => {
								e.preventDefault()
								return false;
							}} onCopy={(e) => {
								e.preventDefault()
								return false;
							}}
							onChange={handleEmailChange}
							error={erroremail}
							helperText={erroremail && "Email non valida"}
							InputLabelProps={{ shrink: true }}
							required={true}
						/>
					</Grid>
					<Grid item xs={12} className="px-2" style={{ marginTop: "20px" }}>
						<TextField
							className="w-100"
							id="emailRepeat"
							label="Ripeti Email"
							variant="outlined"
							value={emailRepeat}
							onPaste={(e) => {
								e.preventDefault()
								return false;
							}} onCopy={(e) => {
								e.preventDefault()
								return false;
							}}
							onChange={handleEmailRepeatChange}
							error={erroremail}
							helperText={erroremail && "Email non valida"}
							InputLabelProps={{ shrink: true }}
							required={true}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleConferma}>SALVA E INVIA EMAIL DI VERIFICA</SDialogButton>
			</DialogActions>
		</Dialog>
	);
}

export default AggiungiEmailDialog;
